module.exports = __webpack_public_path__ + "static/media/Vectormoon.6dccefed.svg";